module.exports = require("@native-ads/antd");


//////////////////
// WEBPACK FOOTER
// external "@native-ads/antd"
// module id = 3
// module chunks = 0